const COLORS = {
  red: {
    h: 0,
    s: 63,
    l: 48
  },
  orange: {
    h: 38,
    s: 84,
    l: 50
  },
  green: {
    h: 111,
    s: 52,
    l: 45
  },
  teal: {
    h: 173,
    s: 100,
    l: 34
  },
  blue: {
    h: 201,
    s: 98,
    l: 41
  },
  purple: {
    h: 262,
    s: 60,
    l: 48
  },
  pink: {
    h: 316,
    s: 70,
    l: 43
  }
} as const

/**
 * All possible colour names that are allowed e.g. red, green
 */
export type ColourName = keyof typeof COLORS

export default COLORS
